import React, { useState } from 'react';
import axios from 'axios';

const API = 'https://cotizaciones-fabrica-rivera-production.up.railway.app/api';

export default function Login() {
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(`${API}/auth/login`, { email, password });
      localStorage.setItem('token', res.data.token);
      localStorage.setItem('usuario', JSON.stringify(res.data.usuario));
      window.location.href = '/';
    } catch {
      setError('Correo o contraseña incorrectos');
    }
  };

  return (
    <div style={s.bg}>
      <div style={s.card} className="rf-login-card">
        <h2 style={s.titulo}>La Fábrica D'Rivera</h2>
        <p style={s.sub}>Sistema de Cotizaciones</p>
        <form onSubmit={handleLogin}>
          <input style={s.input} type="email" placeholder="Correo"
            value={email} onChange={e => setEmail(e.target.value)} required />
          <input style={s.input} type="password" placeholder="Contraseña"
            value={password} onChange={e => setPassword(e.target.value)} required />
          {error && <p style={s.error}>{error}</p>}
          <button style={s.btn} type="submit">Ingresar</button>
        </form>
      </div>
    </div>
  );
}

const s = {
  bg:     { minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:'#1a1a2e' },
  card:   { background:'#fff', padding:'2.5rem', borderRadius:'12px', width:'360px', boxShadow:'0 8px 32px rgba(0,0,0,0.2)' },
  titulo: { textAlign:'center', fontSize:'22px', fontWeight:'700', color:'#1a1a2e', marginBottom:'4px' },
  sub:    { textAlign:'center', color:'#888', marginBottom:'2rem', fontSize:'14px' },
  input:  { width:'100%', padding:'12px', marginBottom:'12px', border:'1px solid #ddd', borderRadius:'8px', fontSize:'15px', display:'block' },
  btn:    { width:'100%', padding:'12px', background:'#c8a951', color:'#fff', border:'none', borderRadius:'8px', fontSize:'16px', fontWeight:'600' },
  error:  { color:'red', fontSize:'13px', marginBottom:'10px' },
};